import * as React from "react"
import * as styles from "./styles.module.scss"
import EquityRoof from "../EquityRoof"
import Superscript from "../../Superscript"

const Lead: React.FC = () => {
  return (
    <section className={styles.lead}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.eyebrow}>Welcome Tesla customer</h2>
          <h2 className={styles.heading}>
            Increase your home equity with ongoing savings
          </h2>
        </div>
        <EquityRoof />
        <div className={styles.message}>
          <p className={styles.lead}>
            The Solar Mortgage<Superscript>TM</Superscript> helps your Solar
            Roof to pay for itself by factoring the added financial value,
            including your increased home value and energy savings, into the
            loan. This could be smartest thing you’ve done with your home since
            buying it.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Lead
